import React from "react";
import { format } from "date-fns";

import { dateFormatMonth, dateFormat } from "../../constants/app-constants";

import { getUserStatus } from "../Common/ListOfStatus";
import { DEFAULT_PASSWORD } from "../../services/graphql/queries/auth";
import { withApollo } from "react-apollo";
import ReactModal from "../Common/ReactModal";
import { SET_TIMEOUT_VALUE } from "../../constants/app-constants";
import { errorMessage } from "../../miscellaneous/error-messages";
import { sendNotification } from "../../services/graphql/queries/user";
import { successMsg } from "../../miscellaneous/react-toastify";
class UserView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      reactModalVisible: false,
      modalMessage: "",
      requireCancel: false,
      modalVisible: false,
      sendNotificationVisible:false
    };
  }
  getDepartmentNames(deptArr) {
    let arr = [];
    deptArr.forEach((element) => {
      arr.push(element.description);
    });
    return arr.join(", ");
  }
  setDefaultPassword = () => {
      console.log("User ID:", this.props.user.Id);
    this.props.client
      .mutate({
        mutation: DEFAULT_PASSWORD,
        variables: { id: this.props.user.Id },
        fetchPolicy: "no-cache",
      })
      .then((result) => {
        this.setState({
          modalVisible: true,
        });
      })
      .catch((error) => {
        console.log("~~~error: ", error);
        this.setState({ loading: false, errors: [errorMessage(error)] });
        this.timer = setTimeout(() => {
          this.setState({ errors: [] });
        }, SET_TIMEOUT_VALUE);
      });
  };

  sendInvite = () => {
  const userId = this.props.user.Id; // adjust depending on your data
    console.log("user id of send notification",userId);
    
    this.setState({ loading: true,  });

  this.props.client
    .mutate({
      mutation: sendNotification,
      variables: { id: userId },
      fetchPolicy: "no-cache",
    })
    .then((result) => {
      this.setState({
        // reactModalVisible: true,
        // modalMessage: result.data.sendNotification.message,
        sendNotificationVisible:true,
        loading:false,
      });
      successMsg("Invite sent successfully");
      console.log("message",result.data.sendNotification.message);
      
    })
    .catch((error) => {
      console.error("~~~error: ", error);
      this.setState({ loading: false, errors: [error.message] ,});
      successMsg("Failed to send invite");
      this.timer = setTimeout(() => {
        this.setState({ errors: [] });
      }, SET_TIMEOUT_VALUE);
    });
};

  // submitModal = () => {
  //   this.setState(
  //     {
  //       reactModalVisible: false,
  //     },
  //     () => {
  //       this.setDefaultPassword();
  //     }
  //   );
  // };

  submitModal = () => {
  this.setState(
    {
      reactModalVisible: false,
    },
    () => {
      if (this.state.sendNotificationVisible) {
        
        this.setState({ sendNotificationVisible: false }); 
        console.log("Send Invite modal closed");
        
      } else {
       
        this.setDefaultPassword();
      }
    }
  );
};

  render() {
    const {
      name,
      // employeeId,
      emailId,
      mobileNumber,
      designationDetail,
      dateOfJoining,
      reportingManager,
      departmentDetail,
      createdByDetail,
      createdOn,
      modifiedByDetail,
      lastModifiedOn,
      status,
      lockedDetail,
    } = this.props.user;
    const {
      reactModalVisible,
      modalMessage,
      requireCancel,
      modalVisible,
    } = this.state;
    const statusName = getUserStatus(parseInt(status))[0];
    var deptNames;
    if (departmentDetail && departmentDetail.length) {
      deptNames = this.getDepartmentNames(departmentDetail);
    }

console.log("user status",this.props.user.status);

    return (
      <div>
        {reactModalVisible ? (
          <ReactModal
            reactModalVisible={reactModalVisible}
            submitModal={() => {
              this.submitModal();
            }}
            modalMessage={modalMessage}
            requireCancel={requireCancel}
            closeModal={() => {
              this.setState({ reactModalVisible: false });
            }}
          />
        ) : null}
        {modalVisible ? (
          <ReactModal
            reactModalVisible={modalVisible}
            submitModal={() => {
              this.setState({ modalVisible: false });
              this.props.onUpdateUser();
            }}
            modalMessage={"Password is reset to default"}
          />
        ) : null}
        <h1 className="heading m-b-25">User Details </h1>
        <div className="row">
          <div className="col-md-12">
            {/* Form Section start */}
            <div className="box-card">
              <div className="row">
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>
                      Name<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={name}
                    />
                  </div>
                </div>
                {/* <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>
                      Employee Id<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={employeeId}
                    />
                  </div>
                </div> */}
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>
                      Email Id for login <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={emailId}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>
                      Mobile number<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={mobileNumber}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>User Type</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        lockedDetail && lockedDetail.entityType == 1
                          ? " External User "
                          : "Jakson Green User"
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>
                      Designation<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        designationDetail && designationDetail.description
                          ? designationDetail.description
                          : ""
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>
                      Date Of Joining<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        dateOfJoining ? format(dateOfJoining, dateFormat) : ""
                      }
                    />
                  </div>
                </div> */}

                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>
                      Reporting Manager <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        reportingManager && reportingManager.name
                          ? reportingManager.name
                          : "-"
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>
                      Department<span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={deptNames}
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Status</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        statusName && statusName.name ? statusName.name : ""
                      }
                    />
                  </div>
                </div>
                {/* <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>User Type</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        lockedDetail && lockedDetail.entityType == 1
                          ? "External User "
                          : "Jakson Green User"
                      }
                    />
                  </div>
                </div> */}
              </div>
              <div className="row">
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Created By</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        createdByDetail && createdByDetail.loginId
                          ? createdByDetail.loginId
                          : ""
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Created On</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        createdOn ? format(createdOn, dateFormatMonth) : ""
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Last Modified By</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        modifiedByDetail && modifiedByDetail.loginId
                          ? modifiedByDetail.loginId
                          : ""
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Last Modified On</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        lastModifiedOn
                          ? format(lastModifiedOn, dateFormatMonth)
                          : ""
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                {/* <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>Status</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        statusName && statusName.name ? statusName.name : ""
                      }
                    />
                  </div>
                </div>
                <div className="col-md-6 col-lg-3">
                  <div className="form-group">
                    <label>User Type</label>
                    <input
                      type="text"
                      readOnly
                      className="form-control-plaintext "
                      value={
                        lockedDetail && lockedDetail.entityType == 1
                          ? "External Investor "
                          : "Jakson Green User"
                      }
                    />
                  </div>
                </div> */}
              </div>
              <div className="row">
                <div className="col-md-12">
                  <button
                    type="button"
                    className="btn btn-danger"
                    onClick={() => {
                      this.props.toggleEditMode();
                    }}
                  >
                    Edit
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger ml-3"
                    onClick={() => {
                      debugger;

                      this.setState({
                        reactModalVisible: true,
                        modalMessage:
                          "Are You Sure.Do you want to reset the password to default password?",
                        requireCancel: true,
                      });
                    }}
                  >
                    Reset Password
                  </button>
                  <>
                  {this.props.user.status === 5 && (
                      
                          <button
                              className=" btn-sendNotification btn btn-danger ml-3"
                              type=""
                              onClick={this.sendInvite}
                              disabled={this.state.loading}
                          >
                                   {this.state.loading ? "Sending..." : "Resend Invite"}
                          </button>
                     )}
                  </>
                  {/* <div className="col-md-6 col-lg-3 bg-primar">
                     {this.props.user.status === 5 && (
                      
                          <button
                              className=" btn-sendNotification btn btn-danger"
                              type=""
                              onClick={this.sendInvite}
                          >
                                   Resend Invite
                          </button>
                     )}

                </div> */}
                </div>
              </div>
            </div>
            {/* Form Section End */}
          </div>
        </div>
      </div>
    );
  }
}

export default withApollo(UserView);
